import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-decline",
  "use": "icon-decline-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-decline\"><defs><style type=\"text/css\"></style></defs><path d=\"M180.224 86.698667L512 418.474667l330.410667-330.410667A62.805333 62.805333 0 0 1 887.466667 68.266667a68.266667 68.266667 0 0 1 68.266666 68.266666 61.44 61.44 0 0 1-18.432 45.056L603.477333 512l333.824 333.824A61.44 61.44 0 0 1 955.733333 887.466667a68.266667 68.266667 0 0 1-68.266666 68.266666 62.805333 62.805333 0 0 1-47.104-18.432L512 605.525333l-331.093333 331.093334A62.805333 62.805333 0 0 1 136.533333 955.733333a68.266667 68.266667 0 0 1-68.266666-68.266666 61.44 61.44 0 0 1 18.432-45.056L420.522667 512 86.698667 178.176A61.44 61.44 0 0 1 68.266667 136.533333a68.266667 68.266667 0 0 1 68.266666-68.266666c16.384 0.2048 32.085333 6.826667 43.690667 18.432z\" fill=\"\" p-id=\"5755\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/decline.svg
// module id = GkXH
// module chunks = 25